import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { PartnersWorkspace } from "@/components/partners-workspace";
import { validatePartnersSearch } from "@/lib/search";
import { Route as RootRoute } from "./__root";

export const Route = createFileRoute("/partners/")({
  validateSearch: validatePartnersSearch,
  component: PartnersIndexPage,
});

function PartnersIndexPage() {
  const { user } = RootRoute.useRouteContext();
  return (
    <DashboardShell userLabel={user?.displayName || user?.loginName || ""}>
      <PartnersWorkspace />
    </DashboardShell>
  );
}
